import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../../handlers/http-responses-handler';
import { BaseDataService } from '../base.data.service';
import { Injectable } from '@angular/core';
import { SupplierMetricsDTO } from '../../interfaces/gamification/supplier-metrics.dto';
import { RateCardPresetDTO } from '../../interfaces/rate-card-presets/rate-card-preset.dto.interface';
import { JobRejectionReasonDTO } from '../../interfaces/job-rejection/job-rejection-reason.dto.interface';
import { CreateRateCardPresetDTO } from '../../interfaces/rate-card-presets/create-rate-card-preset.dto.interface';

@Injectable({
  providedIn: 'root',
})
export class RateCardPresetService {
  url = '/api/rate-card-presets';
  entityTitle = 'RateCard Presets';

  constructor(public http: HttpClient) {}

  createPreset(dto: CreateRateCardPresetDTO): Promise<RateCardPresetDTO> {
    return this.http.post<any>(`${this.url}`, dto).toPromise();
  }

  getPresets(): Promise<RateCardPresetDTO[]> {
    return this.http.get<RateCardPresetDTO[]>(`${this.url}`).toPromise();
  }

  getPreset(id: number): Promise<RateCardPresetDTO> {
    return this.http.get<RateCardPresetDTO>(`${this.url}/${id}`).toPromise();
  }

  patchPricing(id: number, patch: any) {
    return this.http.patch<any>(`${this.url}/${id}/pricing`, patch).toPromise();
  }

  patchPreset(id: number, patch: any) {
    return this.http.patch<any>(`${this.url}/${id}`, patch).toPromise();
  }

  getRateCardData(ratecards) {
    let arrR = [];
    for (let i = 0; i < 3; i++) {
      arrR.push([]);
      for (let j = 0; j < 6; j++) arrR[i].push([]);
    }

    for (let i = 0; i < ratecards.length; i++) {
      arrR[ratecards[i].serviceCard.rateCardType - 1][
        ratecards[i].serviceCard.pricingHoursTypeId - 1
      ].push(ratecards[i]);
    }

    return arrR;
  }
}
